import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const AnalyzingAnswers = lazyWithPreload(
  () => import('./AnalyzingAnswers'),
)
export const LikeChatAnalyzingAnswers = lazyWithPreload(
  () => import('./LikeChatAnalyzingAnswers'),
)
export const AnalyzingAnswersVariant2 = lazyWithPreload(
  () => import('./AnalyzingAnswersVariant2'),
)
